/**
 * Porté depuis apps/web/app/(shop)/cgv/page.tsx (page statique, aucune
 * adaptation nécessaire au-delà de l'abandon de `generateMetadata`, hors
 * périmètre — cf. lot SEO/prérendu séparé).
 *
 * CGV — cadre général rédigé pour être cohérent avec le fonctionnement réel
 * du site (pas de fonctionnalité inventée : paiement COD/mobile money,
 * confirmation téléphonique, pas de paiement carte en ligne). Ce texte n'est
 * pas un document juridique validé — voir l'avertissement en pied de page.
 */
export function CgvPage() {
  return (
    <div className="container-vvs py-8 lg:py-12">
      <h1 className="font-display text-2xl font-bold text-navy sm:text-3xl">
        Conditions générales de vente
      </h1>
      <div className="mt-4 max-w-prose space-y-6 font-body text-sm leading-relaxed text-muted">
        <div>
          <h2 className="font-display text-base font-semibold text-ink">1. Objet</h2>
          <p className="mt-1">
            Les présentes conditions générales de vente régissent les commandes passées par un
            acheteur (« le client ») sur la plateforme VVS — Vendez-Vous eShop (« VVS »),
            marketplace en ligne proposant des produits issus de vendeurs référencés sur la
            plateforme.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">2. Identification du vendeur</h2>
          <p className="mt-1">
            VVS — Vendez-Vous eShop, opérant en Côte d&apos;Ivoire. Les coordonnées de contact
            figurent sur la page Mentions légales et sur la page Contact.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">3. Produits et prix</h2>
          <p className="mt-1">
            Les produits proposés sont décrits et présentés avec la plus grande exactitude
            possible sur leur fiche. Les prix affichés sont exprimés en francs CFA (XOF), toutes
            taxes comprises lorsqu&apos;applicable, hors frais de livraison qui sont calculés et
            affichés séparément avant validation de la commande.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">4. Commande et confirmation</h2>
          <p className="mt-1">
            La commande est passée en ligne par le client, qui renseigne sa commune de livraison
            afin de connaître les frais exacts avant de valider son achat. Après validation, un
            conseiller VVS contacte le client par téléphone pour confirmer la commande avant sa
            préparation et son expédition. La vente n&apos;est considérée comme définitive
            qu&apos;après cette confirmation.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">5. Paiement</h2>
          <p className="mt-1">
            Le règlement s&apos;effectue soit à la livraison (en espèces), soit par mobile money,
            selon le choix du client au moment de la commande. Aucun paiement par carte bancaire
            en ligne n&apos;est proposé à ce jour.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">6. Livraison</h2>
          <p className="mt-1">
            VVS livre à Abidjan et dans les grandes villes de Côte d&apos;Ivoire. Les délais et
            frais de livraison sont indiqués au client avant la validation de sa commande et
            peuvent varier selon la commune de destination.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">7. Droit de rétractation et retours</h2>
          <p className="mt-1">
            Le client peut signaler un article non conforme ou défectueux dans un délai raisonnable
            après réception, selon les modalités décrites sur la page Retours. Certains produits
            peuvent, par leur nature, être exclus du droit de retour (articles personnalisés,
            produits d&apos;hygiène ou de beauté descellés, notamment).
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">8. Garanties</h2>
          <p className="mt-1">
            Les produits vendus sont garantis contre les défauts de conformité manifestes signalés
            dans les conditions prévues à l&apos;article 7. Le client est invité à vérifier son
            article dès réception, notamment lorsque le règlement est effectué à la livraison.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">9. Responsabilité</h2>
          <p className="mt-1">
            VVS agit en qualité d&apos;intermédiaire entre le client et les vendeurs référencés sur
            la plateforme. VVS met en œuvre des moyens raisonnables pour assurer la fiabilité des
            informations publiées, sans que sa responsabilité puisse être engagée pour des
            circonstances échappant à son contrôle raisonnable.
          </p>
        </div>

        <div>
          <h2 className="font-display text-base font-semibold text-ink">10. Litiges et droit applicable</h2>
          <p className="mt-1">
            Les présentes conditions sont soumises au droit ivoirien. En cas de litige, le client
            est invité à contacter VVS en priorité afin de rechercher une solution amiable, avant
            toute autre démarche.
          </p>
        </div>

        <p className="border-t border-line pt-4 text-xs text-muted/80">
          Ce texte constitue un cadre général structurant, rédigé pour refléter le fonctionnement
          actuel du site. Il ne constitue pas un document juridique définitif et doit être validé
          par un professionnel du droit avant toute mise en production définitive.
        </p>
      </div>
    </div>
  );
}
